export const engagementAppGroupIdLinkAliasesGetTriggerableLinks =
  "/engagement/:app_group_id/link_aliases/get_triggerable_links";
